<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Framen" id="_idContainer004">
<p class="ebook-toc" id="_idParaDest-3"><a id="_idTextAnchor002"></a>prologue</p>
<p class="Normal"><span class="CharOverride-2">To heal from your pain</span></p>
<p class="Normal"><span class="CharOverride-2">now,</span></p>
<p class="Normal"><span class="CharOverride-2">you need to go all the way back</span></p>
<p class="Normal"><span class="CharOverride-2">to chapter one.</span></p>
<p class="Normal"><span class="CharOverride-2">To page one.</span></p>
<p class="Normal"><span class="CharOverride-2">To the beginning</span></p>
<p class="Normal"><span class="CharOverride-2">of how it all began.</span></p>
<p class="Normal t1"><span class="CharOverride-2">For every ending,</span></p>
<p class="Normal"><span class="CharOverride-2">there is a </span></p>
<p class="Normal"><span class="poem-itals CharOverride-2">once upon a time</span><span class="CharOverride-2">.</span></p>
<p class="Normal"><span class="CharOverride-2">For every broken soul,</span></p>
<p class="Normal"><span class="CharOverride-2">there is a </span></p>
<p class="Normal"><span class="poem-itals CharOverride-2">once upon a happy soul. </span></p>
<p class="Normal"><span class="CharOverride-2">For every phoenix soaring, </span></p>
<p class="Normal"><span class="CharOverride-2">there is a phoenix </span></p>
<p class="Normal"><span class="CharOverride-2">burning,</span></p>
<p class="Normal"><span class="CharOverride-2">turning to ashes, </span></p>
<p class="Normal"><span class="CharOverride-2">rising, </span></p>
<p class="Normal"><span class="CharOverride-2">then soaring.</span></p>
<p class="Normal t1"><span class="CharOverride-2">Let me hand you the matches </span></p>
<p class="Normal"><span class="CharOverride-2">to ignite the glory </span></p>
<p class="Normal"><span class="CharOverride-2">within your soul. </span></p>
<p class="Normal"><span class="CharOverride-2">Let me be the one </span></p>
<p class="Normal"><span class="CharOverride-2">who burns to ashes </span></p>
<p class="Normal"><span class="CharOverride-2">as you spark in your darkest of nights. </span></p>
<p class="Normal"><span class="CharOverride-2">As you rise. </span></p>
<p class="Normal _idGenParaOverride-1"><span class="CharOverride-2">As you soar.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SparksPhoenix_epub3.vue?a0d96296